export function pointLogTableData(data) {
  return [
    {
      elements: [
        {
          type: "text",
          value: "30 Days Subscription Extension",
        },
      ],
      value: "",
      width: "md:w-[25%]",
    },
    {
      elements: [
        {
          type: "text",
          value:
            "Keep full access to all platform features without any interruption.",
        },
      ],
      value: "",
      width: "md:w-[40%]",
    },
    {
      elements: [
        {
          type: "text",
          value: "5,000",
        },
      ],
      value: "",
      width: "md:w-[10%]",
    },
    {
      elements: [
        {
          render: () => {
            return (
              <div className="flex flex-col text-sm font-bold px-2 py-1 rounded-md text-[#0B662C] bg-[#C4E9E3] w-fit">
                Active
              </div>
            );
          },
        },
      ],
      value: "",
      width: "md:w-[20%]",
    },
    {
      elements: [
        {
          type: "text",
          value: "2025/05/03",
        },
        {
          type: "title",
          value: "10:30AM",
        },
      ],
      value: "",
      width: "md:w-[20%]",
    },
  ];
}
